<kendo-dialog-titlebar class="acb-select-payee-titlebar" (close)="cancel.emit()">
  {{ viewMode == 'edit' ? 'Edit' : 'New' }}
</kendo-dialog-titlebar>

<form class="k-form" [formGroup]="editFeatureForm">

  <acb-alcon-section-with-legend [doShowLegend]="false" class="acb-section-01">

    <div class="acb-fieldset-row" fxLayout="row wrap" fxLayout.xs="column" fxLayoutGap="2em" fxLayoutGap.xs=".125em" [ngClass.xs]="'acb-fieldset-row-small'" #row>

      <kendo-formfield fxFlex="0 0 calc(33.33% - 2em)" *appFieldExtentions>
        <kendo-label [for]="displayName" text="Name"></kendo-label>
        <input formControlName="displayName" kendoTextBox #displayName required autocomplete="off" maxlength="64"/>
        <kendo-formhint>Display name</kendo-formhint>
        <kendo-formerror>Error: Name is required</kendo-formerror>
      </kendo-formfield>

      <!-- <kendo-formfield fxFlex="0 0 calc(33.33% - 2em)" *appFieldExtentions>
        <kendo-label [for]="alternativeName" text="Alternative Name"></kendo-label>
        <input formControlName="alternativeName" kendoTextBox #alternativeName autocomplete="off"/>
        <kendo-formhint>Short Name, Also Known As, AKA</kendo-formhint>
      </kendo-formfield> -->

      <kendo-formfield fxFlex="0 0 calc(33.33% -2em)" *appFieldExtentions>
        <kendo-label [for]="code" text="Code" [optional]="!code.disabled"></kendo-label>
        <input formControlName="code" kendoTextBox #code maxlength="32"/>
        <kendo-formhint *ngIf="!code.disabled">System identifier (auto-generated if left blank)</kendo-formhint>
        <kendo-formhint *ngIf="code.disabled">System identifier</kendo-formhint>
      </kendo-formfield>

      <!-- <kendo-formfield fxFlex="0 0 calc(50% -2em)" fxFlex.sm="0 0 calc(50% - 2em)" fxFlex.gt-md="0 0 calc(25% - 2em)" *appFieldExtentions>
        <kendo-label [for]="displayDescription" text="Description"></kendo-label>
        <textarea formControlName="displayDescription" kendoTextArea #displayDescription rows="3" style="resize: vertical;"></textarea>
        <kendo-formhint>Display Description</kendo-formhint>
      </kendo-formfield>

      <kendo-formfield fxFlex="0 0 calc(50% - 2em)" fxFlex.sm="0 0 calc(50% - 2em)" fxFlex.gt-md="0 0 calc(25% - 2em)" *appFieldExtentions>
        <kendo-label [for]="internalNote" text="Internal Note"></kendo-label>
        <textarea formControlName="internalNote" kendoTextArea #internalNote rows="3" style="resize: vertical;"></textarea>
        <kendo-formhint>ACB note for ACB</kendo-formhint>
      </kendo-formfield> -->



    </div>
    <div class="acb-fieldset-row" fxLayout="row wrap" fxLayout.xs="column" fxLayoutGap="2em" fxLayoutGap.xs=".125em" [ngClass.xs]="'acb-fieldset-row-small'" #row>


      <ng-container *ngIf="this.accessRoles$ | async as accessRolesData">
        <kendo-formfield fxFlex="0 0 calc(33% -2em)" fxFlex.sm="0 0 calc(100% - 2em)" *appFieldExtentions>
          <kendo-label [for]="accessRoles" text="Access Roles"></kendo-label>
          <kendo-multiselect
            formControlName="accessRoles"
            #accessRoles min="0"
            required
            [data]="accessRolesData"
            [textField]="'displayName'"
            [valueField]="'id'"
            [valuePrimitive]="true"
            >
          </kendo-multiselect>
          <kendo-formhint>Who can view this feature</kendo-formhint>
          <kendo-formerror>Error: Code is required</kendo-formerror>
        </kendo-formfield>
      </ng-container>

      <ng-container *ngIf="this.businessRoles$ | async as businessRolesData">
        <kendo-formfield fxFlex="0 0 calc(33% -2em)" fxFlex.sm="0 0 calc(100% - 2em)" *appFieldExtentions>
          <kendo-label [for]="businessRoles" text="Sales Roles" [optional]="true"></kendo-label>
          <kendo-multiselect
            formControlName="businessRoles"
            #businessRoles min="0"
            [data]="businessRolesData"
            [textField]="'displayName'"
            [valueField]="'id'"
            [valuePrimitive]="true"
            >
          </kendo-multiselect>
          <kendo-formhint>Who can view this feature</kendo-formhint>
        </kendo-formfield>
      </ng-container>


      <ng-container *ngIf="this.teams$ | async as teamsData">
        <kendo-formfield fxFlex="0 0 calc(33% -2em)" fxFlex.sm="0 0 calc(100% - 2em)" *appFieldExtentions>
          <kendo-label [for]="teamIDs" text="AM Teams" [optional]="true"></kendo-label>
          <kendo-multiselect
            formControlName="teamIDs"
            #teamIDs min="0"
            [data]="teamsData"
            [textField]="'displayName'"
            [valueField]="'teamID'"
            [valuePrimitive]="true"
            >
          </kendo-multiselect>
          <kendo-formhint>Who can view this feature</kendo-formhint>
        </kendo-formfield>
      </ng-container>


      <!-- <kendo-formfield fxFlex="0 0 calc(25% -2em)" fxFlex.sm="0 0 calc(50% - 2em)"  *appFieldExtentions>
        <kendo-label [for]="delegateFeatureID" text="Delegate Feature"></kendo-label>
        <kendo-combobox
          #delegateFeatureID
          formControlName="delegateFeatureID"
          [data]="featuresForSelected"
          [textField]="'displayName'"
          [valueField]="'featureID'"
          [placeholder]="'Select Delegate'"
          [valuePrimitive]="true"
          [filterable]="true"
          >
        </kendo-combobox>
        <kendo-formhint>Feature redirected to</kendo-formhint>
      </kendo-formfield> -->

      <kendo-formfield fxFlex="0 0 calc(25% -2em)" fxFlex.sm="0 0 calc(50% - 2em)" *appFieldExtentions>
        <kendo-label [for]="parentFeatureID" text="Folder / Parent" [optional]="editFeatureType != 'resource-only'"></kendo-label>
        <kendo-combobox
          #parentFeatureID
          formControlName="parentFeatureID"
          [data]="featuresForSelected"
          [textField]="'displayName'"
          [valueField]="'featureID'"
          [placeholder]="'Select Delegate'"
          [valuePrimitive]="true"
          [filterable]="true"
          [required]="editFeatureType == 'resource-only'"
          >
        </kendo-combobox>
        <kendo-formhint>Folder / parent to appear under</kendo-formhint>
        <kendo-formerror>Error: Folder / Parent is required</kendo-formerror>
      </kendo-formfield>

      <ng-container *ngIf="!editFeatureForm.controls.featureMandateType.disabled">
        <kendo-formfield fxFlex="0 0 calc(33.33% - 2em)" fxFlex.sm="0 0 calc(50% - 2em)" fxFlex.gt-md="0 0 calc(25% - 2em)" *appFieldExtentions>
          <kendo-label [for]="featureMandateType" text="Feature Mandate"></kendo-label>
          <kendo-dropdownlist
            #featureMandateType
            formControlName="featureMandateType"
            [data]="featureMandateTypes$ | async"
            [textField]="'displayName'"
            [valueField]="'id'"
            [valuePrimitive]="true"
            required
            [fxHide]="featureMandateType.disabled"
            >
          </kendo-dropdownlist>
          <kendo-formhint>Concern this belongs to</kendo-formhint>
          <kendo-formerror>Error: Feature Mandate is required</kendo-formerror>
        </kendo-formfield>
      </ng-container>

      <ng-container *ngIf="editFeatureType != 'resource-only'">
        <kendo-formfield fxFlex="0 0 calc(33% - 2em)" fxFlex.sm="0 0 calc(50% - 2em)" fxFlex.gt-md="0 0 calc(25% - 2em)" *appFieldExtentions>
          <kendo-label [for]="visibilityType" text="Visibility"></kendo-label>
          <kendo-dropdownlist
            #visibilityType
            formControlName="visibilityType"
            [data]="visibilityTypes$ | async"
            [textField]="'displayName'"
            [valueField]="'id'"
            [valuePrimitive]="true"
            required
            >
          </kendo-dropdownlist>
          <kendo-formhint>Show or hide in menu</kendo-formhint>
          <kendo-formerror></kendo-formerror>
        </kendo-formfield>
      </ng-container>

      <kendo-formfield fxFlex="0 0 calc(33% - 2em)" fxFlex.sm="0 0 calc(50% - 2em)" fxFlex.gt-md="0 0 calc(25% - 2em)" *appFieldExtentions>
        <kendo-label [for]="statusCode" text="Status Code"></kendo-label>
        <kendo-dropdownlist
          #statusCode
          formControlName="statusCode"
          [data]="featureStatusCodes$ | async"
          [textField]="'displayName'"
          [valueField]="'statusCodeID'"
          [valuePrimitive]="true"
          required
          >
        </kendo-dropdownlist>
        <kendo-formhint>Feature status</kendo-formhint>
        <kendo-formerror>Error: Status Code is required</kendo-formerror>
      </kendo-formfield>

      <kendo-formfield fxFlex="0 0 calc(25% - 2em)" fxFlex.sm="0 0 calc(25% - 2em)" [ngClass.md]="'hide-extention-label'"   *appFieldExtentions>
        <kendo-label [for]="sortOrder" text="Sort Order" [optional]="true"></kendo-label>
        <kendo-numerictextbox formControlName="sortOrder" #sortOrder [min]="0" [format]="{maximumFractionDigits: 0}" inputmode="numeric" type="number"></kendo-numerictextbox>
        <kendo-formhint>Display order</kendo-formhint>
      </kendo-formfield>



    </div>

    <hr />

    <div class="acb-fieldset-row" fxLayout="row wrap" fxLayout.xs="column" fxLayoutGap="2em" fxLayoutGap.xs=".125em" [ngClass.xs]="'acb-fieldset-row-small'" #row>
      <kendo-formfield fxFlex="0 0 calc(25% - 2em)" fxFlex.sm="0 0 calc(50% - 2em)" *appFieldExtentions>
        <kendo-label [for]="featureType" text="Feature Type" *ngIf="featureType.value"></kendo-label>
        <kendo-dropdownlist
          #featureType
          formControlName="featureType"
          [data]="featureTypes$ | async"
          [textField]="'displayName'"
          [valueField]="'id'"
          [valuePrimitive]="true"
          required
          >
        </kendo-dropdownlist>
        <kendo-formhint>Feature's purpose</kendo-formhint>
        <kendo-formerror>Error: Feature Type is required</kendo-formerror>
      </kendo-formfield>


      <ng-container *ngIf="selectedFeatureType == FeatureType.Route">
        <kendo-formfield fxFlex="0 0 calc(75% -2em)" fxFlex.sm="0 0 calc(50% - 2em)" *appFieldExtentions>
          <kendo-label [for]="uri" text="URI"></kendo-label>
          <input formControlName="uri" kendoTextBox #uri autocomplete="off"/>
          <kendo-formhint>URL, Uniform Resource Identifier, Resource Path</kendo-formhint>
        </kendo-formfield>

        <kendo-formfield fxFlex="0 0 calc(50% -2em)" *appFieldExtentions>
          <kendo-label [for]="reportID" text="Report"></kendo-label>
          <kendo-combobox
            #reportID
            formControlName="reportID"
            [data]="(reports$ | async)"
            [textField]="'displayName'"
            [valueField]="'reportID'"
            [placeholder]="'Select Report'"
            [valuePrimitive]="true"
            [filterable]="true"
            >
          </kendo-combobox>
          <kendo-formhint>Feature redirected to</kendo-formhint>
        </kendo-formfield>
      </ng-container>

      <ng-container *ngIf="selectedFeatureType == FeatureType.Resource">

        <div fxLayout="column" fxLayoutGap="1px" class="acb-edit-feature-file-section">
          <kendo-label text="File"></kendo-label>
          <div fxLayout="row" class="acb-feature-resource" fxLayoutGap="1em" *ngIf="this.editFeatureForm?.value?.resource; else noResource">
            <!-- <div #fileName class="acb-feature-resource-name">{{ this.editFeatureForm?.value?.resource }}</div> -->
            <button kendoButton (click)="onViewImage()" class="acb-feature-resource-name"><span class="k-icon k-i-eye"></span> {{ this.editFeatureForm.value.resource }}</button>
            <button kendoButton (click)="onRemoveClick()" icon="delete"></button>
          </div>
          <ng-template #noResource>
            <form [formGroup]="fileUploadForm">
              <kendo-upload
                #fileUpload
                formControlName="files"
                [autoUpload]="true"
                [saveUrl]="'./api/FileUpload'"
                [removeUrl]="'./api/FileDelete'"
                [multiple]="false"
                [(ngModel)]="files"
                [showFileList]="false"
                (upload)="onUpload($event)"
                (remove)="onRemove($event)"
                (success)="onSuccess($event)"
                (error)="onError($event)"
                (select)="onSelect($event)"
                (valueChange)="onValueChange($event)"
                [restrictions]="{
                  allowedExtensions: extensions,
                  maxFileSize: 104857600
                }"
              >
                <kendo-upload-messages select="Upload" dropFilesHere="...or drop file here">
                </kendo-upload-messages>
              </kendo-upload>
            </form>
          </ng-template>
        </div>
      </ng-container>
    </div>



    <!-- <div class="acb-section-buttons">
      <button type="submit" kendoButton [primary]="true" [disabled]="editFeatureForm.pristine" (click)="onSaveFeature()">Save</button>
      <button kendoButton (click)="cancel.emit()">Cancel</button>
    </div> -->
  </acb-alcon-section-with-legend>
  <kendo-dialog-actions>
    <button kendoButton class="acb-cancel" (click)="cancel.emit()"><span class="k-icon k-i-cancel"></span>Cancel</button>
    <button kendoButton [primary]="true" (click)="onSaveFeature()" [disabled]="!editFeatureForm.valid" ><span class="k-icon k-i-checkmark"></span>{{ viewMode == 'edit' ? 'Update' : 'Save' }}</button>
  </kendo-dialog-actions>

</form>
